import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    themeColors: {
      theme: '#BA9566',
      bg: '#f9f9f9',
      text: '#444444',
      textSub: '#999999',
      textTips: '#C6C6C6',
      textLink: '#2F86F6',
      textAdd: '#FA563E',
      textMin: '#1db270'
    },
    tenantId: null,
    customerDetail: {},
    basicConfig: {},
    yiqianbaoDetail: null,
    showBankManage: true,
    servicePhone: '400-6099-200',
    serviceLink: 'http://webchat.yixin.com/pzxzt/receive.html?',
    contactData: {
      registerAddress: '北京市朝阳区建国路乙118号12层01D、02A-02F、03A-03C',
      workAddress: '北京市朝阳区建国路乙118号12层01D、02A-02F、03A-03C',
      homeURL: 'https://www.puzefund.com/',
      time: '工作日 9:00-18:00',
      email: 'vip@puzefund.com'
    },
    bankData: {
      name: '宜信普泽（北京）基金销售有限公司',
      no: '70160078801300006720',
      bank: '浦发银行武汉分行'
    },
    showGanggang: false,
    chooseBank: {
      bankSerial: '',
      bankName: ''
    },
    chaoBaoList: [],
    selectedChaoBaoRow: null,
    sellOrderSon: {},
    buyOrderSon: {},
    dividendFundType: [],
    transfromFund: null,
    transfromResult: {},
    showOutManDialog: false,
    selectedTrusteeFund: null,
  },
  getters: {
    customerDetail (state) {
      return state.customerDetail
    },
    yiqianbaoDetail (state) {
      return state.yiqianbaoDetail
    },
    themeColors (state) {
      return state.themeColors
    },
    showBankManage (state) {
      return state.showBankManage
    },
    contactData (state) {
      return state.contactData
    },
    servicePhone (state) {
      return state.servicePhone
    },
    serviceLink (state) {
      return state.serviceLink
    },
    bankData (state) {
      return state.bankData
    },
    showGanggang (state) {
      return state.showGanggang
    },
    chooseBank (state) {
      return state.chooseBank
    },
    chaoBaoList (state) {
      return state.chaoBaoList
    },
    selectedChaoBaoRow (state) {
      return state.selectedChaoBaoRow
    },
    dividendFundType (state) {
      return state.dividendFundType
    },
    transfromFund (state) {
      return state.transfromFund
    },
    transfromResult (state) {
      return state.transfromResult
    },
    showOutManDialog (state) {
      return state.showOutManDialog
    },
    selectedTrusteeFund (state) {
      return state.selectedTrusteeFund
    }
  },
  mutations: {
    updateThemeColors (state, data) {
      state.themeColors = {
        ...state.themeColors,
        ...data
      }
    },
    updateCustomerDetail (state, data) {
      state.customerDetail = data
      // window.localStorage.setItem('customerDetail', JSON.stringify(data || ''))
    },
    updateBasicConfig (state, data) {
      state.basicConfig = data
    },
    updateYiqianbaoDetail (state, data) {
      state.yiqianbaoDetail = data
    },
    UploadChooseBank (state, data) {
      state.chooseBank = data
    },
    updateChaoBaoList (state, data) {
      state.chaoBaoList = data
    },
    updateSelectedChaoBaoRow (state, data) {
      state.selectedChaoBaoRow = data
    },
    updateSellOrderSon (state, data) {
      state.sellOrderSon = data
    },
    updateBuyOrderSon (state, data) {
      state.buyOrderSon = data
    },
    updateDividendFundType (state, data) {
      state.dividendFundType = data
    },
    updateTransfromFund (state, data) {
      state.transfromFund = data
    },
    updateTransfromResult (state, data) {
      state.transfromResult = data
    },
    updateShowOutManDialog (state, data) {
      state.showOutManDialog = data
    },
    updateTradePasswordFlag (state, data) {
      state.customerDetail.tradePasswordFlag = data
    },
    updateSelectedTrusteeFund (state, data) {
      state.selectedTrusteeFund = data
    }
  },
  actions: {
    updateThemeColors ({ commit }, data) {
      commit('updateThemeColors', data)
    },
    updateCustomerDetail ({ commit }, data) {
      commit('updateCustomerDetail', data)
    },
    updateBasicConfig ({ commit }, data) {
      commit('updateBasicConfig', data)
    },
    updateYiqianbaoDetail ({ commit }, data) {
      commit('updateYiqianbaoDetail', data)
    },
    UploadChooseBank ({ commit }, data) {
      commit('UploadChooseBank', data)
    },
    updateChaoBaoList ({ commit }, data) {
      commit('updateChaoBaoList', data)
    },
    updateSelectedChaoBaoRow ({ commit }, data) {
      commit('updateSelectedChaoBaoRow', data)
    },
    updateDividendFundType ({ commit }, data) {
      commit('updateDividendFundType', data)
    },
    updateTransfromFund ({ commit }, data) {
      commit('updateTransfromFund', data)
    },
    updateTransfromResult ({ commit }, data) {
      commit('updateTransfromResult', data)
    },
    updateShowOutManDialog ({ commit }, data) {
      commit('updateShowOutManDialog', data)
    },
    updateSelectedTrusteeFund ({ commit }, data) {
      commit('updateSelectedTrusteeFund', data)
    }
  },
  modules: {
  }
})
